import { ComponentSize } from '../common-utils/component-size.enum';

export interface CrudFormConfigItemSettings {
  /* Label component size */
  labelComponentSize?: ComponentSize;
  /* Input components size */
  inputComponentSize?: ComponentSize;
}
